import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.js";
import { store } from "./store";
import { Provider } from "react-redux";

import { ThemeProvider } from "@material-tailwind/react";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";

const root = ReactDOM.createRoot(document.getElementById("root"));
let persistor = persistStore(store);
root.render(
  <React.StrictMode>
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider>
          <App />
      </ThemeProvider>
        </PersistGate>
    </Provider>
  </React.StrictMode>
);
